import { RolesMap } from '@/models/user'
import { RouteRecordRaw } from 'vue-router'
import CatalogModule from './CatalogModule.vue'
// import Catalog from './views/Catalog.vue'
import CreateLabor from './Labor/views/CreateLabor.vue'
import ShowLabor from './Labor/views/ShowLabor.vue'
import ListLabor from './Labor/views/ListLabor.vue'
import CreateMaterial from './Material/views/CreateMaterial.vue'
import ShowMaterial from './Material/views/ShowMaterial.vue'
import ListMaterials from './Material/views/ListMaterials.vue'
// import CreateService from './Service/views/CreateService.vue'
// import ShowService from './Service/views/ShowService.vue'
// import ListServices from './Service/views/ListServices.vue'
import ListBudgetTemplates from './BudgetTemplate/views/ListBudgetTemplates.vue'
import CreateBudgetTemplate from './BudgetTemplate/views/CreateBudgetTemplate.vue'
import ShowBudgetTemplate from './BudgetTemplate/views/ShowBudgetTemplate.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/catalog',
    component: CatalogModule,
    meta: { authorize: [RolesMap.EMPLOYEE_ROLE] },
    children: [
      {
        path: 'labor',
        name: 'ListLabor',
        component: ListLabor,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'labor/new',
        name: 'CreateLabor',
        component: CreateLabor,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'labor/:id',
        name: 'ShowLabor',
        component: ShowLabor,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'materials',
        name: 'ListMaterials',
        component: ListMaterials,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'materials/new',
        name: 'CreateMaterial',
        component: CreateMaterial,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'materials/:id',
        name: 'ShowMaterial',
        component: ShowMaterial,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      // {
      //   path: 'services',
      //   name: 'ListServices',
      //   component: ListServices,
      //   meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      // },
      // {
      //   path: 'services/new',
      //   name: 'CreateService',
      //   component: CreateService,
      //   meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      // },
      // {
      //   path: 'services/:id',
      //   name: 'ShowService',
      //   component: ShowService,
      //   meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      // },
      {
        path: 'budget-templates',
        name: 'ListBudgetTemplates',
        component: ListBudgetTemplates,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'budget-templates/new',
        name: 'CreateBudgetTemplate',
        component: CreateBudgetTemplate,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'budget-templates/:id',
        name: 'ShowBudgetTemplate',
        component: ShowBudgetTemplate,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      }
    ]
  }
]

export default routes
